<template>
  <v-dialog v-model="orderDocumentDialog" width="500">
    <v-card>
      <v-card-title>
        Downloading
        <v-spacer/>
        <span v-if="fileDone">
          <v-icon class="mr-2 mb-1" color="green">mdi-check</v-icon> Done
        </span>
      </v-card-title>
      <v-card-text>
        <div class="mt-5 text-center">
          <v-progress-circular
            v-if="!fileDone"
            color="primary"
            indeterminate
          />
          <div v-else>
            <v-btn :href="fileUrl" size="small" target="_blank" variant="text">
              Didnt start downloading automatically?
              <v-icon class="ml-2" size="x-small">mdi-open-in-new</v-icon>
            </v-btn>

            <p v-if="popupBlocked" class="text-caption text-error mt-3">
              It looks like your browser blocked the download. Please click the button above to start it manually.
            </p>
          </div>
          <v-progress-linear
            v-if="!fileDone"
            :model-value="downloadProgress"
            class="mt-5"
            rounded
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import {computed, onMounted, onUnmounted, ref, watch} from 'vue';
import {useStore} from 'vuex';
import {EventBus} from '@/plugins/eventBus';

// Reactive state
const popupBlocked = ref(false);
const downloadProgress = ref(0);
const orderDocumentDialog = ref(false);
const currentWorkingOrderDocumentUuid = ref<string | null>(null);

// Vuex store
const store = useStore();

// Computed properties
const downloadStatus = computed(() => store.getters['order/downloadStatus']);

const fileUrl = computed(() => downloadStatus.value?.url);
const fileDone = computed(() => downloadStatus.value?.done);
const fileStatus = computed(() => downloadStatus.value?.status?.status);

// Actions
const downloadOrderDocument = (documentUuid: string) => {
  store.dispatch('order/downloadOrderDocument', documentUuid);
};

// Event handlers
const handleOpenDownloadDialog = (document_uuid: string) => {
  orderDocumentDialog.value = true;
  currentWorkingOrderDocumentUuid.value = document_uuid;
  downloadOrderDocument(document_uuid);
};

const handleDownloadSuccess = (status: any) => {
  if (['started', 'queued'].includes(status?.status?.status)) {
    setTimeout(() => {
      if (currentWorkingOrderDocumentUuid.value) {
        downloadOrderDocument(currentWorkingOrderDocumentUuid.value);
      }
      downloadProgress.value += 33;
    }, 3 * 1000);
  }
};

// Watchers
watch(fileDone, (status) => {
  if (status) {
    const popup = window.open(fileUrl.value, '_blank');
    if (popup) {
      popup.focus();
      popupBlocked.value = false;
    } else {
      console.warn('Popup was blocked or failed to open.');
      popupBlocked.value = true;
      downloadProgress.value = 0;
    }
  }
});

watch(fileStatus, (status) => {
  console.dir(status);
});
watch(orderDocumentDialog, (status) => {
  if (!status) {
    currentWorkingOrderDocumentUuid.value = null;
    popupBlocked.value = false;
  }
});

// Lifecycle hooks
onMounted(() => {
  EventBus.$on('open-download-order-document-dialog', handleOpenDownloadDialog);
  EventBus.$on('start-order-document-download-success', handleDownloadSuccess);
});

onUnmounted(() => {
  EventBus.$off('open-download-order-document-dialog', handleOpenDownloadDialog);
  EventBus.$off('start-order-document-download-success', handleDownloadSuccess);
});
</script>
